import update from 'immutability-helper'
import { sendWs, TEAMS, SET_OBSERVER } from './send'
import { setDispTeams } from '../redux/actions/teams'
import store from '../redux/store'

export const movingIndex = target => {
  const { teams } = store.getState()
  let teamIndex = null
  let playerIndex = null
  teams.disp.some((team, ti) => {
    const pi = team.players.indexOf(target)
    if (pi !== -1) {
      teamIndex = ti
      playerIndex = pi
      return true
    }
    return false
  })
  return [teamIndex, playerIndex]
}

export const movingPlayerOrder = (teamIndex, fromPlayerIndex, toPlayerIndex) => {
  const { teams } = store.getState()
  const player = teams.disp[teamIndex].players[fromPlayerIndex]
  const dispTeams = update(teams.disp, {
    [teamIndex]: {
      players: { $splice: [[fromPlayerIndex, 1], [toPlayerIndex, 0, player]] }
    }
  })
  store.dispatch(setDispTeams(dispTeams))
}

export const movedPlayerOrder = () => {
  const { teams } = store.getState()
  sendWs(TEAMS, teams.disp)
}

export const cancelMovePlayerOrder = () => {
  const { teams } = store.getState()
  store.dispatch(setDispTeams(teams.orig))
}

export const movePlayerTeam = (fromTeamIndex, fromPlayerIndex, toTeamIndex) => {
  const { teams } = store.getState()
  const player = teams.disp[fromTeamIndex].players[fromPlayerIndex]
  const newTeams = update(teams.disp, {
    [fromTeamIndex]: {
      players: { $splice: [[fromPlayerIndex, 1]] }
    },
    [toTeamIndex]: {
      players: { $push: [player] }
    }
  })
  store.dispatch(setDispTeams(newTeams))
  sendWs(TEAMS, newTeams)
}

export const movePlayerObserver = (teamIndex, playerIndex) => {
  const { teams } = store.getState()
  const player = teams.disp[teamIndex].players[playerIndex]
  sendWs(SET_OBSERVER, player)
}
